import React from 'react';

class ImageOption extends React.Component {
	render() {
		const checked = this.props.checked;

		const checkImage = checked ? (
			<img style={{
				width: 24,
				height: 24,
				marginLeft: 4
			}} src={ require('../assets/checked_white.png') }/>
		) : null;

		const backgroundColor = checked ? 'rgba(34, 142, 220, 0.7)' : 'rgba(0, 0, 0, 0.2)';

		return (
			<div className="pointer" onClick={this.props.onClick} style={{
				borderRadius: 8,
				width: this.props.width,
				height: this.props.height,
				overflow: 'hidden',
				position: 'relative',
				boxSizing: 'border-box',
				border: checked ? '1px solid #008ADF' : null,
				overflowWrap: 'break-word'
			}}>
				<img style={{
					width: '100%',
					height: '100%'
				}} src={this.props.src}>
				</img>
				<div style={{
					position: 'absolute',
					left: 0,
					right: 0,
					bottom: 0,
					height: 60,
					backgroundColor,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center'
				}}>
					<span style={{
						fontSize: 20,
						fontWeight: 500,
						color: 'white',
						textAlign: 'center',
						overflow: 'hidden',
						paddingLeft: 4,
						paddingRight: 4
					}}>
						{this.props.title}
					</span>
					{checkImage}
				</div>
			</div>
		);
	}
}

export default ImageOption;


// WEBPACK FOOTER //
// ./src/components/imageoption.jsx